/* External dependencies */
import { Div, Row } from 'atomize';
import { Link, Trans } from 'gatsby-plugin-react-i18next';
import React from 'react';

/* Local dependencies */
import './style.scss';

export default function ArticlesNav() {
  const menuList = [
    {
      link: `/`,
      name: <Trans>AboutTheApp</Trans>,
    },
    {
      link: `/for-doctors`,
      name: <Trans>forDoctorsAndClinicsText</Trans>,
    },
  ];

  return (
    <Row
      d={{ xs: 'none', lg: 'flex' }}
      textColor="grayTextInCard"
      zIndex="5"
      className="nav"
    >
      {menuList.map((link, index) => (
        <Div
          key={index}
          m={{ b: { xs: '10px', xl: '0' } }}
          className="article-nav-item"
          d="flex"
          justify="space-between"
          align="center"
        >
          <Div p={{ y: '10px' }} d="flex" align="center">
            <Link
              to={link.link}
              className="article-nav-link transition-link"
              activeClassName="active"
            >
              {link.name}
            </Link>
          </Div>
        </Div>
      ))}
    </Row>
  );
}
